import { Zap, Building2, Sun, Smartphone, Car, BatteryCharging, Rocket, ArrowUpRight } from "lucide-react";
import { waLink, IMAGES } from "../data/site";
import { Overline, SectionTitle, Accent, Reveal } from "./Reveal";

const wa = (msg) => waLink(msg);

const Card = ({ icon: Icon, tag, title, text, href, className = "", image, testid }) => {
  const internal = href.startsWith("/");
  return (
  <a
    href={href}
    {...(internal ? {} : { target: "_blank", rel: "noopener noreferrer" })}
    data-testid={testid}
    className={`group relative rounded-2xl border border-white/10 bg-[#0B261E]/60 overflow-hidden transition-[border-color,transform] duration-300 hover:border-[#00E676]/50 hover:-translate-y-1.5 ${className}`}
  >
    {image && (
      <div className="absolute inset-0">
        <img src={image} alt="" loading="lazy" className="w-full h-full object-cover opacity-25 transition-transform duration-700 group-hover:scale-108" />
        <div className="absolute inset-0 bg-[#0B261E]/70" />
      </div>
    )}
    <div className="relative p-7 sm:p-8 h-full flex flex-col">
      <div className="flex items-start justify-between">
        <span className="grid place-items-center w-12 h-12 rounded-xl bg-[#00E676]/12 border border-[#00E676]/25 text-[#00E676]">
          <Icon size={22} />
        </span>
        <span className="text-[10px] font-mono2 uppercase tracking-widest text-[#A3E635] border border-[#A3E635]/30 rounded-full px-3 py-1">
          {tag}
        </span>
      </div>
      <h3 className="mt-6 font-heading text-lg sm:text-xl font-bold text-white">{title}</h3>
      <p className="mt-2 text-sm text-emerald-100/55 leading-relaxed flex-1">{text}</p>
      <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#00E676]">
        Ver como funciona
        <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </span>
    </div>
  </a>
  );
};

export const Services = () => (
  <section id="servicos" className="relative py-24 sm:py-32 bg-[#04120E]" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Overline>Tudo num só lugar</Overline>
        <SectionTitle className="max-w-3xl">
          Muito além do <Accent>desconto na conta de luz</Accent>.
        </SectionTitle>
        <p className="mt-4 max-w-2xl text-sm sm:text-base text-emerald-100/55">
          Escolha por onde começar. Eu te atendo em todos.
        </p>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-5">
        <Reveal className="md:col-span-8" delay={0}>
          <Card
            testid="service-energia"
            icon={Zap} tag="até 15%" title="Desconto na conta de luz"
            text="Energia solar de usinas parceiras para casas e pequenas empresas. Sem obra e sem investimento."
            href="/energia"
            image={IMAGES.solarField}
            className="h-full"
          />
        </Reveal>
        <Reveal className="md:col-span-4" delay={0.08}>
          <Card
            testid="service-empresas"
            icon={Building2} tag="contas altas" title="Energia para empresas"
            text="Para contas de energia altas: economia maior para quem consome muito."
            href="/energia-empresas"
            className="h-full"
          />
        </Reveal>
        <Reveal className="md:col-span-4" delay={0.12}>
          <Card
            testid="service-solar"
            icon={Sun} tag="sem investimento" title="Energia solar no seu telhado"
            text="Painéis instalados sem você investir, ou o seu próprio sistema com projeto e instalação."
            href="/energia-solar"
            image={IMAGES.rooftop}
            className="h-full"
          />
        </Reveal>
        <Reveal className="md:col-span-4" delay={0.16}>
          <Card
            testid="service-telecom"
            icon={Smartphone} tag="a partir de R$ 54,90" title="Celular iGreen Telecom"
            text="Planos 5G com ligações e WhatsApp ilimitados e internet que acumula. Sem fidelidade."
            href="/telecom"
            className="h-full"
          />
        </Reveal>
        <Reveal className="md:col-span-4" delay={0.2}>
          <Card
            testid="service-seguros"
            icon={Car} tag="mensal" title="Seguro auto e moto"
            text="Proteção contra roubo, furto e colisão, com pagamento mensal e sem fidelidade."
            href="/seguros"
            className="h-full"
          />
        </Reveal>
        <Reveal className="md:col-span-6" delay={0.24}>
          <Card
            testid="service-mob"
            icon={BatteryCharging} tag="novo" title="Eletropostos iGreen Mob"
            text="Recarga para carros elétricos, com app para localizar e acompanhar."
            href="/mob"
            className="h-full"
          />
        </Reveal>
        <Reveal className="md:col-span-6" delay={0.28}>
          <Card
            testid="service-licenciado"
            icon={Rocket} tag="empreendedorismo" title="Seja licenciado iGreen"
            text="Empreenda com a iGreen: conheça a licença, os treinamentos e o suporte para começar."
            href="/seja-licenciado"
            className="h-full"
          />
        </Reveal>
      </div>
    </div>
  </section>
);
